<template lang="pug">
  .view-control-settings-user-groups
    b-table(:data="userGroups.items" :loading="userGroups.$state.loading")
      b-table-column(field="id" label="ID" width="30" numeric sortable v-slot="{row}") {{ row.id }}
      b-table-column(field="name" label="Название" sortable v-slot="{row}")
        //- div(v-if="row.system") {{ row.title }}
        .table-row-input: input(:ref="`input-${row.id}`" type="text" v-model="row.title" @keyup.enter="row.$save()")

      b-table-column(field="actions" label="Действия" width="30" v-slot="{row}")
        div()
          .field.has-addons(v-if="row.$isChanged")
            .control
              ui-button.is-rounded.is-small(@click="row.$reset()") Отмена
            .control
              ui-button.is-rounded.is-small.is-success(v-if="row.$isChanged" @click="row.$save()" icon="check") Сохранить
          .field(v-else)
            //- ui-button.is-small.is-rounded(@click="editRow(row)" icon="pencil-circle" icon-type="is-info") Редактировать
            ui-button.is-small.is-rounded(
              v-if="!row.system"
              @click="confirmDeleteRow(row)"
              icon="close"
              icon-type="is-danger"
            )
              | Удалить

      //- Добавление новой группы пользователей
      template(slot="footer")
        th(colspan="3")
          form(@submit.prevent)
            .field.has-addons
              .control.is-expanded
                b-input(type="text" v-model="newUserGroup.name" placeholder="Добавить элемент" :loading="newUserGroup.$state.saving")
              .control
                ui-button.is-primary(icon="plus" :disabled="!newUserGroup.$isChanged" @click="saveNewUserGroup") Добавить
            //- .field
              b-checkbox(
                v-if="newUserGroup.name"
                v-model.number="newUserGroup.isManager"
                true-value="1"
                false-value="0"
              )
                | Менеджер

      //- Пусто
      template(v-slot:empty)
        section.section(v-if="userGroups.$state.loaded")
          .content.has-text-grey.has-text-centered
            p: b-icon(icon="emoticon-sad" size="is-large")
            p Нет записей
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import UserGroup from '@/models/UserGroup';
import { ToastProgrammatic as Toast } from 'buefy';
import { DialogProgrammatic as Dialog } from 'buefy';

export default {
  name: 'view-control-settings-user-groups',

  data: () => ({
    newUserGroup: new UserGroup(),
  }),

  computed: {
    ...mapGetters(['userGroups']),
  },

  methods: {
    ...mapMutations(['setUserGroups']),

    editRow(row) {
      this.$refs[`input-${row.id}`].focus();
    },

    confirmDeleteRow(role) {
      // TODO: Вынести в отдельный сервис (services/notification)
      Dialog.confirm({
        message: 'Вы уверены?',
        cancelText: 'Отменить',
        confirmText: 'Удалить',
        type: 'is-danger',
        onConfirm: async () => {
          try {
            const roleName = role.name;
            await role.$delete();
            Toast.open({
              message: `Группа пользователей “${roleName}” удалена`,
              type: 'is-success',
            });
            this.setUserGroups(this.userGroups.items.filter(userGroup => userGroup.id !== role.id));
          } catch (e) {
            Toast.open({
              message: `Не удалось удалить группу пользователей “${role.name}”`,
              type: 'is-danger',
            });
          }
        },
      });
    },

    async saveNewUserGroup() {
      await this.newUserGroup.$save();

      this.userGroups.add(this.newUserGroup);

      this.newUserGroup = new UserGroup();
    },
  },
};
</script>
